import { render, staticRenderFns } from "./introContent.vue?vue&type=template&id=6d5e87db"
import script from "./introContent.vue?vue&type=script&lang=js"
export * from "./introContent.vue?vue&type=script&lang=js"
import style0 from "./introContent.vue?vue&type=style&index=0&id=6d5e87db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports